import { useSearchInput } from './useSearchInput'
import React from 'react'

const component = 'jobs-search'

export function SearchInput() {
    const { currentSearchTerm, inputRef, handleChange } = useSearchInput()

    return (
        <div className={`${component}__input`}>
            <input
                ref={inputRef}
                type="search"
                value={currentSearchTerm}
                onChange={handleChange}
                className={`${component}__input-field`}
                placeholder="Search..."
                aria-label={'Search'}
            />
        </div>
    )
}
